import { render, staticRenderFns } from "./chirp-message.vue?vue&type=template&id=218fe41f&scoped=true&"
import script from "./chirp-message.vue?vue&type=script&lang=js&"
export * from "./chirp-message.vue?vue&type=script&lang=js&"
import style0 from "./chirp-message.vue?vue&type=style&index=0&id=218fe41f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218fe41f",
  null
  
)

export default component.exports